import SimpleBar from 'simplebar'
import ResizeObserver from 'resize-observer-polyfill';

export const swatchSlider = () => {
  document.addEventListener('DOMContentLoaded', () => {
    window.ResizeObserver = ResizeObserver;
  });
}